import { awsApiInstance } from '../api/aws-api';

import { ICardGroupInsertUpdate, ICardGroupPost } from '../models/cardgroup.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Updates an individual card group
 * 
 * @param {ICardGroupInsertUpdate} group the card group data to be updated
 * 
 * @returns {ICardGroupPost} the api response
 */
const AwsUpdateCardGroup = async (group: ICardGroupInsertUpdate): Promise<ICardGroupPost> => {
  try {

    const modelData = {
      wpId: group.wpId,
      cardGroupId: group.cardGroupId,
      customerId: group.customerId,
      cardGroupName: group.cardGroupName,
      paymentMethod: group.paymentMethod,
      marginCents: group.marginCents,
      hoseType: group.hoseType,
      timeoutOverride: group.timeoutOverride,
      terminalTax: group.terminalTaxes
    }; 

    const { data } = await awsApiInstance.put(`/card-group/${group.cardGroupId}`, modelData);

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error updating card group');
    throw(error);
  }
}

export default AwsUpdateCardGroup;